let iframeContact360timeout,
    swipers = {
    reservation: {
        slider: false,
        elem: $('.js-reservation-gallery-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 'auto',
            simulateTouch: false,
            speed: 400,
            autoHeight: true,
            spaceBetween: 20,
            navigation: {
                nextEl: '.js-reservation-gallery-slider-next',
                prevEl: '.js-reservation-gallery-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            on: {
                slideChange: function() {
                    bLazy.revalidate();
                }
            }
        }
    }
};

Event.on('Window.resized', function() {
    checkSliders(swipers);
});

$(function() {
    checkSliders(swipers);

    $(".js-reservation-gallery-slider").lightGallery({
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false,
        selector: ".js-lightbox",
        galleryId: 2
    });

    $('.js-form-reservation').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            const $message = $('.js-reservation-message'),
                $submitButton = $('.js-reservation-submit');

            $message.slideUp(150);

            $submitButton
                .addClass('is-loading')
                .prop('disabled', true);

            Form.ajaxPost(form, function (data) {
                const status = data.status,
                    $form = $('.js-form-reservation');

                $message
                    .text(data.message)
                    .toggleClass('c-msg--success', !!status)
                    .toggleClass('c-msg--error', !status)
                    .slideDown(250);

                $submitButton
                    .removeClass('is-loading')
                    .prop('disabled', false);

                resetCaptchas();

                if (status) {
                    if ($(window).scrollTop() > $form.offset().top) {
                        $form.slideHere(50, 250);
                    }

                    $form.find('.c-form__input').each(function() {
                        const $input = $(this);

                        let resetVal = '';

                        if ($input.hasClass('is-spinner')) {
                            resetVal = 1;
                        }

                        if ($input.hasClass('is-spinner') || $input.hasClass('is-spinner')) {
                            $('.js-time-date').data('daterangepicker').setStartDate(moment());
                            $('.js-time-fake').data('daterangepicker').setStartDate(moment().set({hour: 11, minute: 0})); // TODO: min cas

                            return true;
                        }

                        if ($input.is(':checkbox')) {
                            $input.prop('checked', false);
                        } else {
                            $input.val(resetVal);
                        }
                    });
                }
            }, 'json');

            return false;
        }
    });

    $('.js-contact-360-start').on('click', function(event) {
        const $startButton = $(this),
            $iframe = $('.js-contact-360-iframe'),
            $wrapper = $('.js-contact-360-wrapper');

        event.preventDefault();

        $wrapper.removeClass('is-loaded');
        $wrapper.addClass('is-loading');

        $iframe.one('load', function() {
            if (iframeContact360timeout) {
                clearTimeout(iframeContact360timeout);
            }

            iframeContact360timeout = setTimeout(function() {
                $wrapper.removeClass('is-loading');
                $wrapper.addClass('is-loaded');
            }, 2500);
        });

        $iframe.attr('src', $('.js-contact-360-select.is-active').data('link'));
    });

    $('.js-contact-360-select').on('click', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('is-active')) {
            $('.js-contact-360-select').removeClass('is-active');
            $(this).addClass('is-active');
            $('.js-contact-360-start').click();
        }
    });
});